import { RootState } from '../root.reducers';
import { Network } from './network.types';

export const getNetworks = (state: RootState): Network[] => state.network.entities;
export const getNetwork = (state: RootState): Network | null => state.network.single;
export const getNetworkCreatedId = (state: RootState): string | null => state.network.createdId;

export const isNetworkCreatePopupOpen = (state: RootState): boolean => state.network.ui.isCreatePopupOpen;
export const isNetworkLoading = (state: RootState): boolean => state.network.ui.isLoading;
